import script from "./Navigation.vue?vue&type=script&setup=true&lang=js"
export * from "./Navigation.vue?vue&type=script&setup=true&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=3a302481&scoped=true&lang=css"

import exportComponent from "/builds/websites/koch-bus-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a302481"]])

export default __exports__